<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputPostalCode" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
</script>

<InputText
    bind:value
    placeholder = 'resource.address.properties.postal_code.placeholder'
    label = 'resource.address.properties.postal_code.label'
    name = 'address.postalCode'
    minLength = { 2 }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>